export default {
  title: 'Histovery | Dashboard',
  dashboard_access: 'Dashboard access',
  navbar: {
    tab: {
      tabs: 'My tabs',
      dashboard: 'Dashboard',
      dashboards: 'Dashboards',
      uses: 'Uses',
      exploitation: 'Operations',
      download: 'Download',
      admin: 'Admin',
      session: 'Session',
    },
  },
  sign_in: 'Sign in',
  sign_in_google: 'Sign in with Google',
  logging_in: 'Signing in...',
  legend: 'Legend',
  sign_out: 'Sign out',
  unsubscribe: 'Unsubscribe',
  users: 'Users',
  select_users: 'Select users',
  email: 'Email',
  emails: 'Emails',
  password: 'Password',
  comments: 'Comments',
  bookmarks: 'Bookmarks',
  'bookmarks.mine': 'My bookmarks',
  'bookmarks.others': 'Others',
  comments_found: 'Comments found',
  display_literacy: 'Display literacy',
  my_favourites: 'My favourites',
  shared_with_me: 'Shared with me',
  score_null: 'This comment has not been analyzed yet.',
  survey: 'Survey',
  the: 'the',
  in: 'in',
  at: 'at',
  level: 'Level',
  comments_lists: {
    title: 'Comments lists',
    create_new_list: 'Create new list',
    comments_number: 'Comments number',
    litteracy: 'Litteracy',
    visit: 'Visit',
    configurate_lists: 'Configurate lists',
    delete_lists: 'Delete lists',
    quality: 'Quality',
  },
  admin: {
    user: {
      create: 'User {0} created with success!',
      update: 'User {0} just updated',
      delete: 'User {0} deleted',
    },
    site: {
      create: 'Site {0} created with success!',
      update: 'Site {0} just updated',
      delete: 'Site {0} deleted',
    },
  },
  modal: {
    title_creation_chart: 'Create a new chart',
    title_config_chart: 'Chart configuration {0}',
    tab_data_header: 'Select the data to study',
    tab_options_header: 'Display options',
    new_request_infos: 'Query new data if modified',
    display_mode: 'Display mode',
    display_grid: 'Grid',
    display_weekend: 'Week-end in background',
    chart_type: 'Chart type',
    data_type: 'In...',
    in: 'In',
    zoom: 'Zoom',
    stacked: 'Stacked',
    type_of_data: 'Data type',
    filters: 'Filters',
    data_value: 'I want to see the...',
    distribution_type: 'Distributed by',
    title: 'Title',
    title_fr: 'French title',
    title_en: 'English title',
    xTitle: 'X Title',
    yTitle: 'Y Title',
    dashboard_title: "Dashboard's title",
    tab_title: "Tab's title",
    share_dashboard: 'Share dashboard "{0}"',
    share_tab: 'Share tab "{0}"',
    share_comment: 'Share comment',
    confirm_chart_delete: 'Are you sure you want to delete that graph?',
    confirm_dashboard_delete: 'Are you sure you want to delete that dashboard "{0}"?',
    confirm_tab_delete: 'Are you sure you want to delete that tab "{0}"?',
    confirm_user_delete: 'Are you sure you want to delete that user: {0}?',
    confirm_site_delete: 'Are you sure you want to delete that site: {0} ?',
    confirm_sending_mail:
      'Are you sure you want to send the after visit email again for that user: {0} ?',
  },
  display_options_title: 'Display options',
  display_options: {
    expanded: 'Expanded',
    compact: 'Compact',
    none: 'None',
  },
  settings: 'Settings',
  filters: 'Filters',
  add_filters: 'Add filters',
  preconfig: 'Preset filters?',
  add: 'Add',
  add_chart: 'Add chart',
  create: 'Create',
  delete: 'Delete',
  share: 'Share',
  edit: 'Edit',
  copy: 'Copy',
  role: 'Role',
  auth_type: 'Type of account',
  validate: 'Validate',
  duplicate: 'Duplicate',
  save: 'Save',
  confirm: 'Confirm',
  cancel: 'Cancel',
  sort: {
    by_date_desc: 'Decreasing dates',
    by_date_asc: 'Increasing dates',
    by_rating_desc: 'Decreasing ratings',
    by_rating_asc: 'Increasing ratings',
    by_score_desc: 'Decreasing scores',
    by_score_asc: 'Increasing scores',
    by_device_serial_desc: 'Decreasing device serial',
    by_device_serial_asc: 'Increasing device serial',
    by_site_id_desc: 'Decreasing site',
    by_site_id_asc: 'Increasing site',
    by_site_location_desc: 'Decreasing site',
    by_site_location_asc: 'Increasing site',
    by_value_desc: 'Decreasing value',
    by_value_asc: 'Increasing value',
    by_alpha_desc: 'Z -> A',
    by_alpha_asc: 'A -> Z',
    none: 'None',
  },
  sort_by: 'Sort by',
  view_by: 'View by',
  display_by: 'Display by',
  suggestion: 'Suggestion',
  select_all: 'All',
  sites: 'Sites',
  'site.title': 'Site',
  'site.edit': 'Edit a site',
  'site.add': 'Add a site',
  'site.name': 'Site name',
  'site.name_placeholder': 'Name of the new site',
  'site.site_id': 'Site ID',
  'site.site': 'Site',
  'site.site_location': 'Site location',
  'site.site_id_placeholder': 'Site ID',
  'site.launch_date': 'Launch date',
  'site.end_date': 'End date',
  'site.status': 'Status',
  'site.status.active': 'Active',
  'site.status.inactive': 'Inactive',
  'site.log_version': 'Log version used',
  'site.has_survey': 'Has survey ?',
  'site.has_map': 'Has maps ?',
  'site.default_level': 'Niveau par défaut',
  'site.levels': 'Niveaux du site',
  'site.url_placeholder': 'Add an authorized hostname',
  'site.products': 'Products',
  'site.languages': 'Languages',
  'site.total_treasure_count': 'Total treasure count',
  comment: 'Comment',
  download: {
    session: 'Download log file',
    sessions: 'Download logs',
    comments: 'Download comments',
    survey: 'Download survey answers',
    chart_config: 'Download chart configuration in JSON file',
    map_data: 'Download route data',
    contents: 'Download the contents best-of',
    comment_email:
      "There are too many comments on the selected period. An Excel file containing the survey's answers will be sent to your email address: {0} soon.",
    survey_email:
      "There are too many answers to the survey on the selected period. An Excel file containing the survey's answers will be sent to your email address: {0} soon.",
    logs_email:
      'There are too many logs to recover over the selected period. A Google Cloud Storage link to a ZIP file containing the logs will be sent to your email address: {0}',
    logs_confirmation: 'Are you sure you want to download all the selected logs?',
    logs_confirmation_infos:
      'You are about to download <strong> {0} </strong> logs, which will take time and generate expenses for the associated Google BigQuery request. You can validate your request by clicking on the confirm button.',
  },
  add_comment: 'Add comment to',
  added_new_list_comment_confirmation: 'Comment added to the list "{0}"!',
  added_comment_confirmation: 'Comment added!',
  shared_comment_confirmation: 'Comment shared!',
  delete_dashboard_warning: "Can't delete your last dashboard.",
  add_comment_error: 'An error occurred while adding the comment, please try again',
  select_list: 'Select one or more list',
  create_list: 'Create a new list',
  add_and_create: 'Create and add',
  lists: 'Lists',
  list: 'List',
  upload_chart_config: 'Upload chart configuration in JSON file',
  date: 'Date',
  visiting_time: 'Visiting time',
  rating: 'Rating',
  start: 'Start of visit',
  end: 'End of visit',
  upload: 'Upload',
  others: 'Others',
  affluence: 'Affluence',
  used_tablets: 'Used tablets',
  used_tablet: 'Used tablet',
  survey_respondents: 'of respondents',
  survey_infos:
    '<strong>{0}</strong> answers for <strong>{1}</strong> visits, <strong>{2} %</strong> of visits',
  type: 'Type',
  value: 'Value',
  category: 'Category',
  session: {
    id: 'Session n°',
    time: 'Visit time',
    site: 'Session from site',
    duration: 'Visit duration',
    viewed_immersives: 'Viewed immersives',
    viewed_va: 'Viewed augmented visits',
    clicked_hotspots: 'Clicked hotspots',
    opened_cartels: 'Opened cartels',
    viewed_io: 'Viewed IO',
  },
  send: 'Send?',
  'send.time': 'Sending time',
  open: 'Opened?',
  'open.time': 'Opening time',
  database: 'In the database ?',
  yes: 'Yes',
  no: 'No',
  by: 'by',
  'confirm.send': 'The after visit email has been created! It will be send in a few minutes...',
  'failure.send': 'A problem occurred during the generation of the email. Please try again.',
  display: 'Display',
  support: {
    email: 'Email Support',
    send_confirmation: 'All emails after visit have been send to this email address: {0}',
    email_found_html:
      'We found <strong>{0}</strong> visits with this email address: <strong>{1}</strong>. Do you want to resent the accorded after visit email(s)?',
    email_found:
      'We found {0} visits with this email address: {1}. Do you want to re-sent the accorded after visit email(s)?',
    no_email_found: 'No visit found with this email address: ',
    send_error: 'An error occurred while sending after visit emails: {0}',
  },
  content: {
    bestof: 'Contents best of',
    name: 'Name',
    total: 'Total of openings/clicks',
    sessions_rate: 'Usage rate on the session total',
    uses_rate: 'Usage rate over total uses',
    indicator: '<strong>{0}</strong> interactions pour <strong>{1}</strong> visites',
  },
  batteries: 'Batteries',
  battery: {
    level: 'Battery level',
    levels: 'Battery levels',
    informations: 'Battery information',
    gradients: 'Evolution of battery gradients',
    temperature: 'Battery temperature',
    temperatures: 'Battery temperatures',
    gradient: 'Battery gradients distribution',
    last: 'Battery levels distribution at the end of visit',
    subtitle: '{0} sessions on {1}',
    infos_levels: 'Battery levels per session over time ({0} sessions)',
    infos_temperatures: 'Battery temperatures per session over time({0} sessions)',
    infos_level_points: 'Battery levels per session over time ({0} sessions)',
    infos_temperature_points: 'Battery temperatures per session over time({0} sessions)',
    infos_gradients_distribution: 'Distribution over {0} sessions',
    infos: 'Information about',
    time: 'Time (minute)',
    zoom: 'Zoom',
    grid: 'Grid',
    crashes: 'Crashes',
    over_day: 'Over day',
    status: 'Status',
    bad: 'Bad',
    very_bad: 'Very bad',
    medium: 'Medium',
    good: 'Good',
  },
  device: 'Device n°',
  serial: 'Serial',
  device_placeholder: 'Device serial',
  device_sessions: 'Sessions and tablets',
  sessions_found: 'sessions found',
  site_id: {
    '1': 'Castle of Chambord',
    '2': 'Grévin Museum',
    '3': 'Fontainebleau',
    '4': 'The Conciergerie',
    '5': 'Epinal',
    '6': "Popes' Palace",
    '7': 'Airborne Museum',
    '8': 'Royal castle of Blois',
    '9': 'Pic du Midi',
    '10': 'Royal city of Loches',
    '11': 'Royal castle of Amboise',
    '12': 'Royal fortress of Chinon',
    '13': 'National museum of U.S. Air Force',
    '14': 'Abbey of Notre-Dame of Sénanque',
    '15': 'Paris City Vision',
    '17': 'Royal Saltworks',
    '18': 'Albrechtsburg',
    '19': 'Moritzburg',
    '20': 'Notre-Dame experience',
    '21': 'ASOM',
    '22': 'Notre-Dame - Bernardins',
    '23': 'Notre-Dame - Washington',
    '24': 'Notre-Dame - Dresde',
  },
  site: {
    'france.chambord.chateau': 'Castle of Chambord',
    'france.paris.grevin': 'Grévin Museum',
    'france.fontainebleau.musee-chinois': 'Fontainebleau Chinese museum',
    'france.paris.conciergerie': 'The Conciergerie',
    'france.epinal.imagerie': "Imagerie d'Epinal",
    'france.avignon.palais-des-papes': 'Palace of the Popes',
    'france.sainte-mere-eglise.airborne-museum': 'Airborne Museum',
    'france.blois.chateau': 'Royal castle of Blois',
    'france.la-mongie.pic-du-midi': 'Pic du Midi',
    'france.loches.donjon': 'Royal city of Loches',
    'france.amboise.chateau': 'Royal castle of Amboise',
    'france.chinon.forteresse': 'Royal fortress of Chinon',
    'usa.dayton.usaf': 'National museum of US Air Force',
    'france.gordes.senanque': 'Abbey of Notre-Dame of Sénanque',
    'france.paris.pcv': 'Paris City Vision',
    'france.arcetsenans.saline': 'Royal Saltworks',
    'deutschland.meissen.albrechtsburg': 'Meissen Albrechtsburg Castle',
    'deutschland.moritzburg.schlossmoritzburg': 'Moritzburg Castle',
    'france.paris.notredame': 'Notre-Dame experience',
    'usa.fayetteville.asom': 'ASOM',
    'france.paris.notredame.bernardins': 'Notre-Dame - Bernardins',
    'usa.washington.notredame': 'Notre-Dame - Washington',
    'deutschland.dresde.notredame': 'Notre-Dame - Dresde',
    'france.bormes-les-mimosas.mhab': 'MHAB',
    'usa.new-orleans.hnoc.notredame.expo': 'Notre-Dame - HNOC',
    'china.shanghai.notredame': 'Notre-Dame - Shangai',
    'france.paris.conciergerie.expogastronomie': 'Conciergerie - Gastronomy Exhibit',
    'notredame.totemexpo': 'Notre-Dame - Totem',
    'meissen.totemexpo': 'Meissen - Totem',
    'mhab.totemexpo': 'MHAB - Totem',
    'deutschland.berlin.mdf.notredame.expo': 'Notre-Dame - Berlin',
    'mexico.mexicocity.notredame.museofranzmayer': 'Notre-Dame - Mexico',
    'canada.montreal.notredame.arsenalcontemporaryart': 'Notre-Dame - Montréal Arsenal',
    'usa.washington.nmusa.expo-dday': 'DDay - NMUSA',
    'germany.colditz.schloss-colditz': 'Colditz',
    'spain.madrid.centrocentro.notredame': 'Notre-Dame - Madrid - CentroCentro',
    'korea.seoul.nationalpalacemuseumofkorea.notredame': 'Notre-Dame - Séoul',
    'france.wizernes.coupole': 'La Coupole',
    'brazil.saopaulo.museudaimagemedosom.notredame': 'Notre-Dame - Sao Paulo - MIS',
    'usa.sanantonio.missionalamo': 'Mission Alamo',
  },
  site_location: {
    'france.chambord.chateau': 'Castle of Chambord',
    'france.paris.grevin': 'Grévin Museum',
    'france.fontainebleau.musee-chinois': 'Fontainebleau Chinese museum',
    'france.paris.conciergerie': 'The Conciergerie',
    'france.epinal.imagerie': "Imagerie d'Epinal",
    'france.avignon.palais-des-papes': 'Palace of the Popes',
    'france.sainte-mere-eglise.airborne-museum': 'Airborne Museum',
    'france.blois.chateau': 'Royal castle of Blois',
    'france.la-mongie.pic-du-midi': 'Pic du Midi',
    'france.loches.donjon': 'Royal city of Loches',
    'france.amboise.chateau': 'Royal castle of Amboise',
    'france.chinon.forteresse': 'Royal fortress of Chinon',
    'usa.dayton.usaf': 'National museum of US Air Force',
    'france.gordes.senanque': 'Abbey of Notre-Dame of Sénanque',
    'france.paris.pcv': 'Paris City Vision',
    'france.arcetsenans.saline': 'Royal Saltworks',
    'deutschland.meissen.albrechtsburg': 'Meissen Albrechtsburg Castle',
    'deutschland.moritzburg.schlossmoritzburg': 'Moritzburg Castle',
    'france.paris.notredame': 'Notre-Dame experience',
    'usa.fayetteville.asom': 'ASOM',
    'france.paris.notredame.bernardins': 'Notre-Dame - Bernardins',
    'usa.washington.notredame': 'Notre-Dame - Washington',
    'deutschland.dresde.notredame': 'Notre-Dame - Dresden',
    'france.bormes-les-mimosas.mhab': 'MHAB',
    'usa.new-orleans.hnoc.notredame.expo': 'Notre-Dame - HNOC',
    'china.shanghai.notredame': 'Notre-Dame - Shangai',
    'france.paris.conciergerie.expogastronomie': 'Conciergerie - Gastronomy Exhibit',
    'notredame.totemexpo': 'Notre-Dame - Totem',
    'meissen.totemexpo': 'Meissen - Totem',
    'mhab.totemexpo': 'MHAB - Totem',
    'deutschland.berlin.mdf.notredame.expo': 'Notre-Dame - Berlin',
    'mexico.mexicocity.notredame.museofranzmayer': 'Notre-Dame - Mexico',
    'canada.montreal.notredame.arsenalcontemporaryart': 'Notre-Dame - Montréal Arsenal',
    'unitedkingdom.london.notredame.westminsterabbey': 'Notre-Dame - Westminster',
    'usa.washington.nmusa.expo-dday': 'DDay - NMUSA',
    'germany.colditz.schloss-colditz': 'Colditz',
    'spain.madrid.centrocentro.notredame': 'Notre-Dame - Madrid - CentroCentro',
    'korea.seoul.nationalpalacemuseumofkorea.notredame': 'Notre-Dame - Séoul',
    'france.wizernes.coupole': 'La Coupole',
    'brazil.saopaulo.museudaimagemedosom.notredame': 'Notre-Dame - Sao Paulo - MIS',
    'usa.sanantonio.missionalamo': 'Mission Alamo',
  },
  state: {
    OK: 'OK',
    KO: 'KO',
    PENDING: 'Pending',
  },
  status: {
    ACTIVE: 'Active',
    INACTIVE: 'Inactive',
  },
  timeline: {
    start: 'Start',
    end: 'End',
    from: 'From',
    to: 'To',
    last_weekend: 'Last week-end',
    last_week: 'Last 7 days',
    last_month: 'Last 30 days',
    last_year: 'Last 365 days',
    year: 'Year {0}',
    since_first_january: 'Since the first of january',
    launch: 'Since launch',
    custom: 'Select',
    select_preset: 'Select preset',
    preset: 'Preset',
  },
  login: {
    custom: 'Custom login',
    please: 'Please sign in',
    email: 'Email address',
    password: 'Password',
    password_confirmation: 'Confirm password',
    or: 'Or',
  },
  chart: {
    save_invalid: 'You must validate or delete the filters in progress...',
    form_invalid: 'Please fill all mandatory fields',
    download_data: 'Download chart data in CSV format or export chart in PNG/SVG format',
    over_period: 'Period from {0} to {1}',
    with_filters: 'with filters',
    copy_info: "Copy chart's settings",
    paste_info: "Paste chart's settings",
    show_config: 'Chart settings',
    what_data: 'What kind of data?',
    how_display: 'How to display it?',
    delete: 'Delete chart',
    time: 'Time chart',
    indicator: 'Indicator',
    pie: 'Pie chart',
    bar: 'Bar chart',
    day: 'Day chart',
    rotation: 'Tablets turnovers',
    battery: 'Battery levels chart',
    grid: 'Grid',
    matrix: 'Heatmap',
    title_suggested: 'Suggested',
    contains_filters: 'This charts contains filters.',
    data_type: {
      count: 'Count',
      average_time: 'Average time',
      average_count: 'Average',
      percentage: 'Percentage',
      distribution: 'Distribution',
      max_time: 'Maximum time spent',
      min_time: 'Minimum time spent',
      session_count: 'Number of sessions',
      duration: 'Duration',
      passages_count: 'Number of passages',
      percentage_passages_count: 'Percentage of passages',
      percentage_sessions_count: 'Percentage of sessions',
      is_crash: 'Crashs',
      no_beacon_detected: 'Beacon not detected',
      beacon_detected: 'Beacon detected',
    },
    data_value: {
      visit: 'Visit',
      email: 'Email',
      comment: 'Comment',
      collected_treasure_count: 'Collected treasures',
      histopad_rating: 'HistoPad rating',
      visit_rating: 'Visit rating',
      histomaton_file: 'HistoSelfie',
      affluence: 'Attendance Peaks',
      is_crash: 'Crash',
      upload: 'Uploaded logs',
      uploaded_time: 'Number of first time uploaded logs',
      uploaded_count: 'Number of uploaded logs per day',
      duplicate: 'Duplicated visits',
      hotspot: 'Hotspots',
      cartel: 'Cartels',
      immersive: 'Immersives',
      interactiveobject: 'Interactive objects',
      interactivebuilding: 'Interactive buildings',
      augmentedvisit: 'Augmented visits',
      interactivecharacter: 'Interactive characters',
      sequence: 'Sequences',
      language: 'Language',
      satisfaction: 'Satisfaction',
      email_delivered: 'Delivered emails',
      email_open: 'Opened emails',
      email_click: 'Clicks in emails',
      email_delivered_session: 'Visits that received the email after visit',
      email_open_session: 'Visits that opened the email after visit',
      email_click_session: 'Visits that clicked in the email after visit',
      survey_answer: 'Survey answer',
      rotation: 'Histopad rotations',
      route_duration: 'Route',
      inactivity_time: 'Inactivity',
      area_visit: 'Area visits',
      beacon: 'Detected beacon',
      warning: 'Warning',
      max_temperature: 'Max temperature',
      min_temperature: 'Min temperature',
      average_temperature: 'Average temperature',
      max_level: 'Max level',
      min_level: 'Min level',
      average_level: 'Average level',
      max_memory_level: 'Max memory level',
      min_memory_level: 'Min memory level',
      average_memory_level: 'Average memory level',
      max_temperature_gradient: 'Max slope of temperature',
      min_level_gradient: 'Max slope of battery level',
      max_memory_level_gradient: 'Max slope of used memory level',
      scan: 'Scan',
      stuck_log: 'Stuck logs',
    },
    data_group: {
      global: 'Global',
      email: 'Emails',
      use: 'Uses',
      technical: 'Technical',
      battery: 'Battery & memory',
    },
  },
  filter: {
    by: 'Filter by',
    all: 'All',
    site_id: 'Site',
    site_location: 'Site',
    total: 'Total',
    others: 'Others',
    add_invalid: 'You must select at least one value from the list',
    select_invalid: 'You must validate the current filter before adding a new one',
    language: 'Language',
    product: 'Produit',
    histopad_rating: 'HistoPad rating',
    visit_rating: 'Visit rating',
    collected_treasure_count: 'Collected treasures',
    duration: 'Duration',
    version: 'Version',
    player_version: 'Player version',
    operating_system: 'OS',
    os_name: 'OS name',
    os_build: 'OS build',
    os_version: 'OS version',
    device_vendor: 'Device vendor',
    device_model: 'Device model',
    site: 'Site',
    bucket: 'Bucket',
    device_name: 'Number of turnovers per tablet',
    state: 'State',
    warning_type: 'Type of warnings',
    status: 'Site status',
    by_site: 'Filter by site',
    by_histopad_rating: 'Filter by HistoPad rating',
    by_language: 'Filter by language',
    by_visit_rating: 'Filter by visit rating',
    by_product: 'Filter by product',
    by_bookmark: 'Filter bookmarks',
    by_list: 'Filter by list',
    quality: 'Readability',
    litteracy: {
      all: 'All',
      bad: 'Low',
      average: 'Average',
      good: 'High',
      medium: 'Medium',
    },
  },
  language: {
    English: 'English',
    French: 'French',
    German: 'German',
    Spanish: 'Spanish',
    Italian: 'Italian',
    Chinese: 'Chinese',
    Japanese: 'Japanese',
    Russian: 'Russian',
    Polish: 'Polish',
    Dutch: 'Dutch',
    Korean: 'Korean',
    Brazilian: 'Brazilian',
    Portuguese: 'Portuguese',
    AmericanEnglish: 'American english',
    'en-GB': 'English',
    'fr-FR': 'French',
    'fr-FALC': 'Simplified french',
    'de-DE': 'German',
    'es-ES': 'Spanish',
    'it-IT': 'Italian',
    'zh-CN': 'Chinese',
    'ja-JP': 'Japanese',
    'ru-RU': 'Russian',
    'pl-PL': 'Polish',
    'nl-NL': 'Dutch',
    'ko-KR': 'Korean',
    'pt-BR': 'Brazilian',
    'pt-PT': 'Portuguese',
    'en-US': 'American english',
    'cs-CZ': 'Czech',
    'ar-AR': 'Arabic',
    'he-HE': 'Hebrew',
    'hu-HU': 'Hungarian',
    'oc-FR': 'Occitan',
    none: 'Not specified',
  },
  star: 'star',
  stars: 'stars',
  treasure: 'treasure',
  treasures: 'treasures',
  product: {
    Standard: 'Standard',
    PMR: 'PMR',
    Guide: 'Tour',
    Pro: 'Pro',
    Histopad45Mins: '45 minutes mode',
    HistopadLSF: 'Deaf and hard of hearing mode',
    AudiopadReducedVision: 'AudioPad',
    '45Min': '45 minutes',
    Travaux: 'Work',
    VisuallyImpaired: 'Partially sighted',
    Deaf: 'Deaf',
    Audiodescription_FR: 'Audiodescription FR',
    Sightless: 'Blind',
    Comfort: 'Comfort',
  },
  warning_type: {
    not_set: 'Not set',
    device_overheating: 'Device overheating',
    high_memory_usage: 'High memory usage',
    low_memory: 'Low memory',
    low_battery: 'Low battery',
    no_beacon_detected: 'No beacon detected',
  },
  sidebar: {
    title_invalid: 'Vous devez saisir au moins un titre valide',
    filters_invalid:
      'Vous devez saisir au moins un titre valide et / ou valider tous les filtres sélectionnés',
  },
  dashboard: {
    create: 'Create a new dashboard',
    duplicate: 'Duplicate dashboard "{0}"?',
    delete: 'Delete dashboard',
    edit: 'Edit dashboard',
    update: "Update dashboard's title",
    add: 'Add a new dashboard to this tab',
    new_header: 'This is a new dashboard!',
    new_info_1: 'But it does not contain any charts yet.',
    new_info_2: 'To add a new chart, click on the button below:',
    form_title_invalid: "Missing dashboard's title",
    form_invalid: 'You must select a chart type and / or validate / delete the current filters...',
  },
  tab: {
    create: 'Create a new tab',
    form_invalid: "You must enter a tab's title",
    duplicate: 'Duplicate tab "{0}"?',
    edit: "Edit tab's title",
    update: "Update tab's title",
    delete: 'Delete tab',
    share: 'Share tab',
  },
  user: {
    edit: 'Edit an user',
    add: 'Add a user',
    admin: 'Administrator',
    administrator: 'Administrator',
    exploitation: 'Exploitation',
    histovery: 'Histovery',
    partner: 'Partner',
    email_placeholder: "New user's email",
    google: 'Google',
    custom: 'Custom',
    password_mismatch: 'Passwords mismatch, please check and try again',
  },
  unit: {
    no: '',
    minute: 'minutes',
    second: 'seconds',
    day: 'per day',
    session: 'per visit',
    percent: '%',
    byte: 'Mb',
    degree: '°C',
    degree_per_minute: '°C / min',
    percent_per_minute: '% / min',
    byte_per_minute: 'Byte / min',
  },
  total: 'in total',
  search: {
    email: 'Search for an email:',
    keyword: 'Search for a keyword:',
    session: 'Search for a session:',
  },
  message: {
    page_not_found: "It looks like the page you requested doesn't exist (or not yet)...",
    error: {
      wrong_login: 'Wrong password or email',
      password_missing: 'Password required',
      email_missing: 'Email required',
      login: 'Unable to login, please verify your email and your password and try again',
      share: 'A problem occured during the sharing, please try again',
      copy: 'A problem occured during the copy, please try again',
      unsubscription: 'An error occured during the unsubscription, please try again',
      data:
        'An error occurred while retrieving data from this chart, please try again by clicking the button on the right',
    },
    infos: {
      dashboard_shared: 'Dashboard shared with success!',
      tab_shared: 'Tab shared with success!',
      unsubscription: 'Your email has been removed from our mailing list!',
      unsubscription_header: 'See you soon! Please click the button below to unsubscribe:',
    },
  },
  footer: 'Histovery Analytics Dashboard version {0}',
  stream_profiles: {
    title: 'Stream Profiles',
    create: 'Create',
    create_tooltip: 'Create a new comments stream',
    name: 'Profile name',
    query: 'Comments query',
    sites: 'Sites',
    display: 'Display',
    languages: 'Languages',
    histopad_rating: 'Histopad rating',
    visit_rating: 'Visit rating',
    limit: 'Comments limit',
    score_min_max: 'Score range',
    fade_comments: 'Comments Fade',
    fade_in: 'FadeIn duration',
    fade_out: 'FadeOut duration',
    seconds: 'seconds',
    distances: 'Security distances',
    display_duration: 'Comments display duration',
    min_edge: 'Comments/Edges',
    min_comments: 'Comments/Comments',
    min_tip: '% of the smallest dimension (width or height)',
    score: 'Score',
    score_size_ratio: 'Score-Font size relationship',
    score_size_ratio_tip: '% score numerical value is added to font size',
    rotation: 'Comments rotation',
    rotation_rate: 'Duration between each new comments displayed',
    randomize_initial_direction: 'Randomize initial direction',
    miscellaneous: 'Miscellaneous',
    active_comments_order: 'Active comments order',
    form_active_comments_order: {
      random: 'Random',
      timeasc: 'Oldest first',
      timedesc: 'Newest first',
    },
    active_particules: 'Active particules (background)',
    display_title: 'Display title',
    colors: 'Colors',
    background_color: 'Background color',
    font_color: 'Font color',
    secondary_color: 'Secondary color',
    submit: 'Submit',
    created_profile: 'Successfully created new profile',
    update: 'Update',
    init: 'No action selected',
    actions: 'Buttons',
    export: 'Export',
    export_code: 'Export code',
    dimensions: 'Width and Height',
    iframe: 'HTML iFrame tag',
    delete: 'Delete',
    delete_confirmation: 'Are you sure to delete? ',
    query_type_choice: 'Comments selection mode',
    bookmark_selection: 'By Bookmark-list',
    filter_selection: 'By filters',
    launch: 'Start',
  },
  areas: 'Areas',
  area: 'Zone',
  maps: 'Maps',
  warnings: 'Warnings',
  maps_data: 'I want to see the',
  map_indicator: {
    average_visit_time: 'Average visit time:',
    visit_number: 'Number of visits:',
    crashs_number: 'Number of crashs:',
    crash: 'Total number of crashes over the period ({0} - {1}):',
    average_time: 'Average visit time over the period ({0} - {1}):',
    count: 'Total number of visits over the period ({0} - {1}):',
    percentage: 'Total number of visits over the period ({0} - {1}):',
    session_count: 'Total number of visits over the period ({0} - {1}):',
    session_percentage: 'Total number of visits over the period ({0} - {1}):',
    max_time: 'Average visit time over the period ({0} - {1}):',
    min_time: 'Average visit time over the period ({0} - {1}):',
    warning_beacon: 'Number of times beacons were not detected over the period ({0} - {1}):',
    warning_device_overheating: 'Number of "device overheating" warnings over period ({0} - {1}):',
    warning_high_memory_usage: 'Number of "high memory usage" warnings over period ({0} - {1}):',
    warning_no_beacon_detected: 'Number of "beacon not detected" warnings over period ({0} - {1}):',
  },
}
